import React from "react";
import { Row, Col, Progress } from "antd";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import {
  InvestmentPerformanceDiv,
  PerformanceData,
  TableDataHeading,
  TableData,
  TableCircleName,
  CategoryName,
  PerformanceCol
} from "./styles";
import Chart from "../Chart/Chart";
import { LinkNavigatorButton } from "../../../../../../CommonComponents/CTA/Buttons";
import {
  WhiteGradient,
  SemiDarkerDivider,
  NoData,
  NoDataDiv
} from "../../../../../../CommonComponents/commonStyles";
import colorMapping from "../../../../../../CommonComponents/colorMapping";
import { initiateTracking, formatAmount } from '../../../../../../utils/commonUtil';
import tooltipIcon from '../../../../../../assets/icons/shape.svg';
import { TooltipCircle,MarketMovementTooltip } from '../Tooltip/styles';
import moment from "moment";
import 'moment-timezone';
import PropTypes from 'prop-types';
import { replaceSelect } from "../../../../../../utils/replacer";

const accountType = "STANDARD";

export default class InvestmentPerformance extends React.Component {
  state = {
    ps: [],
    pb: [],
    vd: []
  };
  colorMappingData = data => {
    return colorMapping[data];
  };
  componentDidMount() {
    let investmentPoolsTableData_ps = [];
    let investmentPoolsTableData_pb = [];
    let investmentPoolsTableData_vd = [];
 
    if (accountType === "STANDARD") {
      this.props.accData.forEach((item) => {
        if (
          item.poolCategory === "PORTFOLIO SOLUTIONS" &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_ps.push(item);
        } else if (
          (item.poolCategory === "BUILDING BLOCKS" ||
            item.poolCategory === "INTERNATIONAL TILTS" ||
            item.poolCategory === "SPECIFIC REGIONS" ||
            item.poolCategory === "BALANCED FUNDS") &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_pb.push(item);
        } else if (
          item.poolCategory === "VALUES DRIVEN INVESTMENTS" &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_vd.push(item);
        }
      });
    } else if (accountType === "SELECT") {
      this.props.accData.forEach(item => {
        if (item.poolCategory === "PORTFOLIO SOLUTIONS") {
          investmentPoolsTableData_ps.push(item);
        } else if (
          (item.poolCategory === "BUILDING BLOCKS" ||
            item.poolCategory === "INTERNATIONAL TILTS" ||
            item.poolCategory === "SPECIFIC REGIONS" ||
            item.poolCategory === "BALANCED FUNDS") &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_pb.push(item);
        } else if (
          item.poolCategory === "VALUES DRIVEN INVESTMENTS" &&
          item.currentBalance > 0
        ) {
          investmentPoolsTableData_vd.push(item);
        }
      });
    }
    this.setState({
      ps: investmentPoolsTableData_ps,
      pb: [...investmentPoolsTableData_pb],
      vd: [...investmentPoolsTableData_vd]
    });
  }

  gotoOptionDetails = (tabIndex, poolName, buttonName) => {
    initiateTracking("learnMore", "Investment Overview", poolName, buttonName);
    this.props.history.push({
      pathname: '/investments/details',
      state: {
        tabIndex,
        poolName
      }
    });
  }

  excerptText = (data, isUnit=false, len = 12) => {    
    if(isUnit) {
      let value = Number(data).toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 });
      return {
        units: value,
        displayUnits: value && value.length > len ? `${value.substr(0, len)}...`: value 
      }          
    } else {
      let value = formatAmount(data);
      return {
        marketVal: value,
        displayMarketVal: value && value.length > len ? `${value.substr(0, len)}...`: value
      }
    }
  }

  render() {
    const { isLoadingAccount } = this.props;
    const { ps, pb, vd } = this.state;
    const buttonName = "Learn More";
    const LCP = "Low Carbon Global Equity";
    if (isLoadingAccount) return <Preloader />;
    return ps.length === 0 && pb.length === 0 && vd.length === 0 ? (
      <NoDataDiv className="no-data mb-50">
        <NoData>
          You currently have no investment performance history.
        </NoData>
      </NoDataDiv>
    ) : (
        <InvestmentPerformanceDiv>
          <PerformanceData>
            {pb.length > 0 && (
              <CategoryName className="mt0">Portfolio Builders</CategoryName>
            )}
            {pb.length > 0 &&
              pb.map((data, index) => {
                let Assetmix_Cal = (data.currentBalance / this.props.main_accdata.currentBalance) * 100;
                let Assetmix_value = Assetmix_Cal.toFixed([2]);
                const { units, displayUnits } = this.excerptText(data.currentUnits, true);
                const { marketVal, displayMarketVal } = this.excerptText(data.currentBalance);    

                return (
                  <div key={index}>
                    <Row className={index === pb.length - 1 ? "" : "my-30"}>
                      <Col lg={{ span: 3 }} md={{ span: 4 }} sm={{ span: 4 }}> 
                          <div>
                            <Progress
                              status="normal"
                              type="circle"
                              percent={parseInt(Assetmix_value)}
                              strokeWidth={10}
                              width={105}
                              strokeLinecap="square"
                              strokeColor={this.colorMappingData(data.poolName)}
                              format={Assetmix_value === 100 ? () => "100%" : () => Assetmix_Cal.toFixed([2])+"%"}
                              />
                          </div>                      
                      </Col>
                      <PerformanceCol
                        lg={{ span: 20 }}
                        md={{ span: 20 }}
                        sm={{ span: 20 }}
                      >
                        <Row>
                          <Col>
                            <TableCircleName>{replaceSelect(data.poolName)}</TableCircleName>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={{ span: 3 }} sm={{ span: 3 }} xs={{ span: 10 }}>
                            <TableDataHeading>NAV 
                                    <MarketMovementTooltip
                                    overlayClassName='market-movemet-tooltip tolltip_arrow'
                                    placement='right'
                                    title={moment(data.dateOfPricePerUnit).format('LL')}
                                    autoAdjustOverflow={true}
                                  >
                                    <TooltipCircle src={tooltipIcon} alt = "tooltipIcon"/>
                                  </MarketMovementTooltip>
                            </TableDataHeading>
                            <TableData>
                              {"$" +
                                Number(data.currentNAV).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                            </TableData>
                          </Col>
                          <Col lg={{ span: 3 }} sm={{ span: 5 }} xs={{ span: 14 }}>
                            <TableDataHeading>Units</TableDataHeading>
                            <TableData title={units}>
                              { displayUnits }
                            </TableData>
                          </Col>
                          <Col lg={{ span: 4 }} sm={{ span: 5 }} xs={{ span: 10 }}>
                            <TableDataHeading>Market value</TableDataHeading>
                            <TableData title={marketVal}>
                              { displayMarketVal }
                            </TableData>
                          </Col>
                          <Col
                            lg={{ span: 5 }}
                            sm={{ span: 6 }}
                            xs={{ span: 14 }}
                            className="mtn-06">
                            <TableDataHeading Navigation>
                              Historical NAV
                            </TableDataHeading>
                            <Chart
                              chartData={data.prices}
                              strokeColor={this.colorMappingData(data.poolName)}
                              width="150"
                              height="60"
                            />
                          </Col>
                          <Col
                            lg={{ span: 4 }}
                            sm={{ span: 4 }}
                            xs={{ span: 18 }}
                            className="mt-05"
                          >
                            <LinkNavigatorButton clicked={() => this.gotoOptionDetails(3, data.poolName, buttonName)} {...{buttonName}} />
                          </Col>
                        </Row>
                      </PerformanceCol>
                    </Row>
                    <SemiDarkerDivider className="w95 mt-md-1-25" />
                  </div>
                )
              })}
            {ps.length > 0 && (
              <CategoryName className="mt0">Portfolio Solutions</CategoryName>
            )}
            {ps.length > 0 &&
              ps.map((data, index) => {
                let Assetmix_Cal = (data.currentBalance / this.props.main_accdata.currentBalance) * 100;
                let Assetmix_value = parseFloat(Assetmix_Cal.toFixed([2]));
                const { units, displayUnits } = this.excerptText(data.currentUnits, true);
                const { marketVal, displayMarketVal } = this.excerptText(data.currentBalance);

                return (
                  <div key={index}>
                    <Row className={index === ps.length - 1 ? "" : "my-30"}>
                      <Col lg={{ span: 3 }} md={{ span: 4 }} sm={{ span: 4 }}>
                          <div>
                            <Progress
                              status="normal"
                              type="circle"
                              percent={Assetmix_value}
                              strokeWidth={10}
                              width={105}
                              strokeLinecap="square"
                              strokeColor={this.colorMappingData(data.poolName)}
                              format={Assetmix_value === 100 ? () => "100%" : () => Assetmix_Cal.toFixed([2])+"%"}                              
                            />
                          </div>           
                      </Col>
                      <PerformanceCol
                        lg={{ span: 20 }}
                        md={{ span: 20 }}
                        sm={{ span: 20 }}
                      >
                        <Row>
                          <Col>
                            <TableCircleName>{replaceSelect(data.poolName)}</TableCircleName>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={{ span: 3 }} sm={{ span: 3 }} xs={{ span: 10 }}>
                            <TableDataHeading>NAV
                            <MarketMovementTooltip
                                    overlayClassName='market-movemet-tooltip tolltip_arrow'
                                    placement='right'
                                    title={moment(data.dateOfPricePerUnit).format('LL')}
                                    autoAdjustOverflow={true}
                                  >
                                    <TooltipCircle src={tooltipIcon} alt = "tooltipIcon"/>
                                  </MarketMovementTooltip>
                            </TableDataHeading>
                            <TableData>
                              {"$" +
                                Number(data.currentNAV).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                            </TableData>
                          </Col>
                          <Col lg={{ span: 3 }} sm={{ span: 5 }} xs={{ span: 14 }}>
                            <TableDataHeading>Units</TableDataHeading>
                            <TableData title={units}>
                              {displayUnits}
                            </TableData>
                          </Col>
                          <Col lg={{ span: 4 }} sm={{ span: 5 }} xs={{ span: 10 }}>
                            <TableDataHeading>Market value</TableDataHeading>
                            <TableData title={marketVal}>
                              {displayMarketVal}
                            </TableData>
                          </Col>
                          <Col
                            lg={{ span: 5 }}
                            sm={{ span: 6 }}
                            xs={{ span: 14 }}
                            className="mtn-06"
                          >
                            <TableDataHeading Navigation>
                              Historical NAV
                        </TableDataHeading>
                            <Chart
                              chartData={data.prices}
                              strokeColor={this.colorMappingData(data.poolName)}
                              width="150"
                              height="60"
                            />
                          </Col>
                          <Col
                            lg={{ span: 5 }}
                            sm={{ span: 4 }}
                            xs={{ span: 18 }}
                            className="mt-05"
                          >
                            <LinkNavigatorButton clicked={() => this.gotoOptionDetails(2, data.poolName, buttonName)} {...{buttonName}} />
                          </Col>
                        </Row>
                      </PerformanceCol>
                    </Row>
                    <SemiDarkerDivider className="w95 mt-md-1-25" />
                  </div>
                )
              })}
            {vd.length > 0 && (
              <CategoryName className="mt0">
                Values-Driven Investments
            </CategoryName>
            )}
            {vd.length > 0 &&
              vd.map((data, index) => {
                let Assetmix_Cal = (data.currentBalance / this.props.main_accdata.currentBalance) * 100;
                let Assetmix_value = Assetmix_Cal.toFixed([2]);
                const { units, displayUnits } = this.excerptText(data.currentUnits, true);
                const { marketVal, displayMarketVal } = this.excerptText(data.currentBalance);
                return (
                  <div key={index}>
                    <Row className={index === vd.length - 1 ? "mb-30" : "my-30"}>
                      <Col lg={{ span: 3 }} md={{ span: 4 }} sm={{ span: 4 }}>
                        <div>                       
                              <div>
                                <Progress
                                  status="normal"
                                  type="circle"
                                  percent={parseInt(Assetmix_value)}
                                  strokeWidth={10}
                                  width={105}
                                  strokeLinecap="square"
                                  strokeColor={this.colorMappingData(data.poolName)}
                                  format={Assetmix_value === 100 ? () => "100%" : () => Assetmix_Cal.toFixed([2])+"%"}                               
                                />
                              </div>                          
                        </div>
                      </Col>
                      <PerformanceCol
                        lg={{ span: 20 }}
                        md={{ span: 20 }}
                        sm={{ span: 20 }}
                      >
                        <Row>
                          <Col>
                            <TableCircleName>{replaceSelect(data.poolName)}</TableCircleName>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={{ span: 3 }} sm={{ span: 3 }} xs={{ span: 10 }}>
                            <TableDataHeading>NAV
                            <MarketMovementTooltip
                                    overlayClassName='market-movemet-tooltip tolltip_arrow'
                                    placement='right'
                                    title={moment(data.dateOfPricePerUnit).format('LL')}
                                    autoAdjustOverflow={true}
                                  >
                                    <TooltipCircle src={tooltipIcon} alt = "tooltipIcon"/>
                                  </MarketMovementTooltip>
                            </TableDataHeading>
                            <TableData>
                              {"$" +
                                Number(data.currentNAV).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                            </TableData>
                          </Col>
                          <Col lg={{ span: 3 }} sm={{ span: 5 }} xs={{ span: 14 }}>
                            <TableDataHeading>Units</TableDataHeading>
                            <TableData title={units}>
                              {displayUnits}
                            </TableData>
                          </Col>
                          <Col lg={{ span: 4 }} sm={{ span: 5 }} xs={{ span: 10 }}>
                            <TableDataHeading>Market value</TableDataHeading>
                            <TableData title={marketVal}>
                              {displayMarketVal}
                            </TableData>
                          </Col>
                          <Col
                            lg={{ span: 5 }}
                            sm={{ span: 6 }}
                            xs={{ span: 14 }}
                            className="mtn-06"
                          >
                            <TableDataHeading Navigation>
                              Historical NAV
                        </TableDataHeading>
                            <Chart
                              chartData={data.prices}
                              strokeColor={this.colorMappingData(data.poolName)}
                              width="150"
                              height="60"
                            />
                          </Col>
                          <Col
                            lg={{ span: 4 }}
                            sm={{ span: 4 }}
                            xs={{ span: 18 }}
                            className={`mt-05 ${data.poolName === LCP ? 'display-none' : '' }`}
                          >
                            <LinkNavigatorButton clicked={() => this.gotoOptionDetails(4, data.poolName, buttonName)} {...{buttonName}} />
                          </Col>
                        </Row>
                      </PerformanceCol>
                    </Row>
                    <SemiDarkerDivider
                      className={
                        index === vd.length - 1 ? "display-none" : "w95 mt-md-1-25"
                      }
                    />
                  </div>
                )
              })}
          </PerformanceData>
          <WhiteGradient />
        </InvestmentPerformanceDiv>
      );
  }
}
InvestmentPerformance.propTypes = {
  accountType: PropTypes.string,
  accData: PropTypes.arrayOf(PropTypes.object),
  isLoadingAccount: PropTypes.bool,
  main_accdata: PropTypes.object,
  ps: PropTypes.array,
  pd: PropTypes.array,
  vd: PropTypes.array,
  investmentPoolsTableData_ps: PropTypes.array,
  investmentPoolsTableData_pb: PropTypes.array,
  investmentPoolsTableData_vd: PropTypes.array,
  gotoOptionDetails: PropTypes.func,
  excerptText: PropTypes.func,
  buttonName: PropTypes.string,
  Assetmix_Cal: PropTypes.number,
  Assetmix_value: PropTypes.number,
  units: PropTypes.string,
  displayUnits: PropTypes.string,
  marketVal: PropTypes.string,
  displayMarketVal: PropTypes.string
}